import { createFileRoute } from "@tanstack/react-router";

import { EnrollmentDashboard } from "../tools/dashboards/EnrollmentDashboard";

function EnrollmentRoute() {
  return <EnrollmentDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/enrollment")({
  component: EnrollmentRoute,
});
